export const spacing = {
  /**
   * @xxs value in pixels: 8px
   */
  xxs: "0.5rem",
  /**
   * @xs value in pixels: 16px
   */
  xs: "1rem",
  /**
  * @sm value in pixels: 24px
  */
  sm: "1.5rem",
  /**
  * @md value in pixels: 32px
  */
  md: "2rem",
  /**
  * @lg value in pixels: 48px
  */
  lg: "3rem",
  /**
  * @xl value in pixels: 64px
  */
  xl: "4rem",
  /**
  * @2xl rem in pixels: 80px
  */
  "2xl": "5rem",
} as const;

export type SpacingKeys = keyof typeof spacing;
export type Spacing = typeof spacing;
